export default "__VITE_ASSET__CI_QSeQM__"